export default "__VITE_ASSET__BJw$vrmg__"